import { Controller } from "@hotwired/stimulus"

const STORAGE_KEY = "quiz_lang"

export default class extends Controller {
  connect() {
    const hasEnContent = document.querySelector("[data-lang='en']") !== null
    if (!hasEnContent) {
      document.body.classList.remove("lang-en")
      return
    }
    const saved = localStorage.getItem(STORAGE_KEY) || "pt"
    document.body.classList.toggle("lang-en", saved === "en")
    this.syncLocaleFields(saved)
  }

  toggle() {
    const isEn = document.body.classList.toggle("lang-en")
    const lang = isEn ? "en" : "pt"
    localStorage.setItem(STORAGE_KEY, lang)
    this.syncLocaleFields(lang)
  }

  private syncLocaleFields(lang: string) {
    document.querySelectorAll<HTMLInputElement>("[data-locale-field]").forEach(el => {
      el.value = lang
    })
    document.querySelectorAll<HTMLInputElement>("[data-placeholder-pt][data-placeholder-en]").forEach(el => {
      el.placeholder = lang === "en"
        ? (el.dataset.placeholderEn ?? "")
        : (el.dataset.placeholderPt ?? "")
    })
  }
}
